import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import DailyLog from "@/pages/DailyLog";
import CalendarPage from "@/pages/CalendarPage";
import People from "@/pages/People";
import Documents from "@/pages/Documents";
import FollowUps from "@/pages/FollowUps";
import Reminders from "@/pages/Reminders";
import Reports from "@/pages/Reports";
import Assistant from "@/pages/Assistant";
import Settings from "@/pages/Settings";
import Search from "@/pages/Search";
import Landing from "@/pages/Landing";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

// Handle Emergent Google auth callback synchronously before regular routing.
function AppRoutes() {
  const location = useLocation();
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="log" element={<DailyLog />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="search" element={<Search />} />
        <Route path="people" element={<People />} />
        <Route path="documents" element={<Documents />} />
        <Route path="followups" element={<FollowUps />} />
        <Route path="reminders" element={<Reminders />} />
        <Route path="reports" element={<Reports />} />
        <Route path="assistant" element={<Assistant />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      {/* Unknown paths fall back to the landing page. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
